import { useContext, useEffect, useState } from 'react'
import { DomainContext } from '../../../../context/DomainContext';
import { SearchParamsLink } from '../../../../utils';

export const useGetTableData = (tableAPI, tableFiller) => {

    const [data, setData] = useState([])
    const [totalRows, setTotalRows] = useState([])

    const { setDataLoading, dataLoading, searchData, customSearchData, reloadTable } = useContext(DomainContext);

    const fetchData = () => {
        let link = SearchParamsLink(searchData, customSearchData, tableFiller)
        setDataLoading(l => l + 1)
        tableAPI(link)
            .then((result) => {
                setDataLoading((l) => l - 1);
                setData(result.data || []);
                setTotalRows(result.totalCount);
            }
            )
            .catch(() => {
                setDataLoading((l) => l - 1);
            });
    };

    console.log(customSearchData)
    
    useEffect(() => {

        const featchDataTimeOut = setTimeout(() => {
            fetchData()
        }, 400)
        return () => clearTimeout(featchDataTimeOut)

    }, [reloadTable, searchData, customSearchData, tableFiller])

    return { data, totalRows }

}
